import React from 'react';
import { ChevronDown } from 'lucide-react';
import './CourseAccordion.css';

// Student panelidagi kurs kartasi (akkordeon). Faqat ko'rinish: ochiq/yopiqlik va
// bosilganda nima bo'lishi tashqaridan (open, onToggle). Tana — children.
export function CourseAccordion({ title, meta, open, onToggle, children }) {
  return (
    <div className={`ui-course-acc ${open ? 'ui-course-acc--open' : ''}`}>
      <button type="button" className="ui-course-acc__toggle" aria-expanded={open} onClick={onToggle}>
        <span className="ui-course-acc__head">
          <span className="ui-course-acc__title">{title}</span>
          {meta && <span className="ui-course-acc__meta">{meta}</span>}
        </span>
        <ChevronDown className="ui-course-acc__chevron" aria-hidden="true" />
      </button>
      {open && <div className="ui-course-acc__body">{children}</div>}
    </div>
  );
}

// Kurs tanasidagi "yorliq — qiymat" qatori
export function CourseAccordionRow({ label, children }) {
  return (
    <div className="ui-course-acc__row">
      <span className="ui-course-acc__label">{label}</span>
      <span className="ui-course-acc__value">{children}</span>
    </div>
  );
}

export default CourseAccordion;
